import { IClauseList } from "@/api";
import { DEFAULT_GUIDANCE_LABEL } from "@/config/constants";
import { Box, Stack, Typography } from "@mui/material";

interface IProps {
    /**
     * The clause to display guidance for
     */
    clause: IClauseList;
}

/**
 * Displays the default guidance for a clause
 */
export const DefaultGuidance = ({ clause }: IProps) => {
    return (
        <Stack gap={2}>
            <Typography fontWeight={500} gutterBottom>
                {DEFAULT_GUIDANCE_LABEL}
            </Typography>

            {/* Default Guidance */}
            <Box
                sx={{
                    bgcolor: "#F9FAFB",
                    px: 2.5,
                    py: 1.5,
                    borderRadius: 1,
                }}
            >
                <Typography variant="body2">"{clause.guidance}"</Typography>
            </Box>
        </Stack>
    );
};
